export default "__VITE_ASSET__52902fb4__"